import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SoundIcon from '../../HOME/SVG/SoundIcon';
import { Sound } from '../Sound';
import { SET_GLOBAL_OPTION } from '../REDUX/actions';
import { DEFAULT_VOLUME } from '../const';
import _ from 'lodash';

const VolumeControl = () => {
  const dispatch = useDispatch();
  const { volume } = useSelector(state => state.common.globalOptions);

  const handleToggleSound = e => {
    dispatch({ type: SET_GLOBAL_OPTION, payload: { name: 'volume', value: -volume || DEFAULT_VOLUME } });
  };

  const handleAdjustVolume = n => {
    const vol = n / 10;
    dispatch({ type: SET_GLOBAL_OPTION, payload: { name: 'volume', value: vol } });
    Sound('tap', vol);
  };

  const vol = Math.abs(volume || DEFAULT_VOLUME) * 10;

  return (
    <div className="options-item">
      <div onClick={handleToggleSound}>
        <SoundIcon on={volume > 0} width="30" />
      </div>
      <div
        style={{
          display: 'grid',
          grid: 'auto/auto auto auto auto auto auto auto auto auto auto',
        }}>
        {_.map([1, 2, 3, 4, 5, 6, 7, 8, 9, 10], n => {
          const fill = volume < 0 || n > vol ? null : 'rgb(84,157,255)';
          return (
            <div key={n} className="volume" id={`volume-${n}`} onClick={() => handleAdjustVolume(n)}>
              <div className="volume-bullet" style={{ background: fill }} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default VolumeControl;
